import { useAppSelector } from '../../store/hooks';
import { Anchor } from "../RequestRespectingInputs";

export function LoginLink()
{
  const loggedInUserName = useAppSelector((state) => state.login.currentUser.username);

  if (!loggedInUserName)
  {
    return <>
      <Anchor to={`user/register`}>Register</Anchor>
      &nbsp;
      <Anchor to={`loginform`}>Log In</Anchor>
    </>;
  }

  return null;
}